import * as LoginActionCreators from './login'
import * as HomeActionCreators from './home'
import * as SalaryActionCreators from './salary'
import * as userActionCreators from './user'
import * as transferActionCreators from './transfers'
import * as accountStatementActionCreators from './accountStatement'
import * as fastmenuActionCreators from './fastmenu'
import * as cardStatementActionCreators from './cardStatement'
import * as salaryCardActionCreators from './salaryCard'
import * as tableActionCreators from './table'
import * as appConfigsCreators from './configs'
import * as globalErrorCreators from './globalError'
import * as ibSigningCreators from './ibsigning'

export default {
    ...LoginActionCreators,
    ...HomeActionCreators,
    ...SalaryActionCreators,
    ...userActionCreators,
    ...transferActionCreators,
    ...accountStatementActionCreators,
    ...fastmenuActionCreators,
    ...cardStatementActionCreators,
    ...salaryCardActionCreators,
    ...tableActionCreators,
    ...appConfigsCreators,
    ...globalErrorCreators,
    ...ibSigningCreators
}
